import { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { useSearchParams } from 'react-router-dom'
import { ModuleWindow } from '../../components/moduleWindow/ModuleWindow'
import { translations } from '../../configs/translations'
import { ClientApi } from '../../services/clientApi'
import PlayerService from '../../services/PlayerService'
import { VehicleService } from '../../services/VehicleService'
import { useStore } from '../../store/store'
import { NuiMessages } from '../../utils/ClientEvents'
import { getTimeFormated } from '../../utils/getTimeFormated'
import { GameHudHints } from '../hud/gamehud-hints/GameHudHints'
import './TestDriveHud.css'

export const TestDriveHud = () => {

	const language = useStore(state => state.language) as keyof typeof translations
	const t = translations[language]

	const [searchParams] = useSearchParams()
	const endsAt = Number(searchParams.get('endsAt')) || new Date().getTime()

	const [endsInStr, setEndsInStr] = useState<string>('0:00')
	const [stringInterval, setStringInterval] = useState<NodeJS.Timeout | null>(null)
	const [leaveModuleWindowVisible, setLeaveModuleWindowVisible] = useState(false)


	const updateDateString = () => {
		const date = new Date(endsAt)
		const now = new Date()
		if (date < now) {
			setEndsInStr('0:00')
			return
		}
		const minutes = Math.floor((date.getTime() - now.getTime()) / (1000 * 60))
		const seconds = Math.floor((date.getTime() - now.getTime()) / 1000) % 60
		setEndsInStr(getTimeFormated(-1, minutes, seconds))
	}

	useEffect(() => {
		if (!stringInterval) {
			updateDateString()
			const interval = setInterval(updateDateString, 1000)
			setStringInterval(interval)
		}
		return () => {
			if (stringInterval) {
				clearInterval(stringInterval)
			}
		}
	}, [endsAt])

	const toggleCursor = (enabled: boolean) => {
		try {
			console.log(`Toggle cursor ${enabled}`)
			enabled ? PlayerService.showCursor() : PlayerService.hideCursor()
		} catch (error) {
			console.log('Unable to toggle cursor, error:', error)
		}
	}

	useEffect(() => {
		ClientApi.on(NuiMessages.TRAINING_HINT, ({ id }: { id: string }) => {
			if (id === 'leave') {
				setLeaveModuleWindowVisible(true)
				toggleCursor(true)
			}
		})
	}, [])

	const handleTestDriveLeave = () => {
		VehicleService.leaveTestDrive()
			.catch((error) => {
				toast.error(
					error?.response?.data && t[error.response.data as keyof typeof t]
						? t[error.response.data as keyof typeof t]
						: t.error_unknown,
					{ className: 'notification-error' }
				)
			})
	}

	return (<>
		<div className='test-drive-hud'>
			<div className='test-drive-until-end-container'>
				<p>{t.event_ends_in}: {endsInStr}</p>
			</div>

			<GameHudHints type='test-drive' />

			{leaveModuleWindowVisible && <ModuleWindow
				title={t.leave}
				text={t.are_you_sure_leave_freeroam}
				onYes={() => {
					void handleTestDriveLeave()
					setLeaveModuleWindowVisible(false)
				}}
				onNo={() => {
					setLeaveModuleWindowVisible(false)
					void toggleCursor(false)
				}}
			/>}
		</div>

		<Toaster
			position="bottom-center"
			reverseOrder={false}
		/>
	</>)

}